<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import AutomationEventInspector from './AutomationEventInspector.vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  event: {
    type: Object,
    default: null,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();

const isOpen = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
});

const close = () => {
  isOpen.value = false;
};
</script>

<template>
  <div
    v-show="modelValue"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
    role="dialog"
    aria-modal="true"
    :aria-label="t('AUTOMATION_EVENTS.DETAIL.TITLE')"
  >
    <div
      class="flex max-h-[90vh] w-full max-w-5xl flex-col overflow-hidden rounded-xl border border-n-weak bg-n-solid-1 shadow-xl"
    >
      <AutomationEventInspector
        class="max-h-[90vh]"
        :event="event"
        :is-loading="isLoading"
        compact
        @close="close"
      />
    </div>
  </div>
</template>
